/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import {
    GUIDE_SET_ENTERED_CHANNEL_NUMBER,
    START_ENTER_CHANNEL_NUMBER,
    STOP_ENTER_CHANNEL_NUMBER,
} from './enterchannelnumber.types';

export const startEnterChannelNumberAction = (): AnyAction => ({
    type: START_ENTER_CHANNEL_NUMBER,
    payload: {
        isEnterChannelNumberActive: true,
        enteredChannelNumber: '',
    },
});

export const stopEnterChannelNumberAction = (): AnyAction => ({
    type: STOP_ENTER_CHANNEL_NUMBER,
    payload: {
        isEnterChannelNumberActive: false,
        enteredChannelNumber: '',
    },
});

export const setEnteredChannelNumberAction = (enteredChannelNumber: string): AnyAction => ({
    type: GUIDE_SET_ENTERED_CHANNEL_NUMBER,
    payload: {
        enteredChannelNumber,
    },
});
